export default __webpack_public_path__ + "static/media/apple.aed8126a.svg";